import type { PropsWithChildren } from 'react';

export enum TableCellContentType {
  CHECKBOX = 'CHECKBOX',
  ACTION = 'ACTION',
  LOADING = 'LOADING',
  GROUP_HEADER = 'GROUP_HEADER',
  SPACER = 'SPACER',
  NO_PADDING = 'NO_PADDING',
  COMPACT = 'COMPACT',
}

export interface TableCellBaseProps extends PropsWithChildren {
  className?: string;
  align?: 'center' | 'left' | 'right';
  width?: number;
  colSpan?: number;
  rowSpan?: number;
  fullRow?: boolean;
  textBold?: boolean;
  breakWord?: boolean;
  noWrap?: boolean;
  dataTestId?: string;
  withRightBorder?: boolean;
}

interface CellWithContentTypeProps {
  title?: never;
  contentType: Exclude<TableCellContentType, TableCellContentType.NO_PADDING | TableCellContentType.COMPACT>;
}

interface CellWithNoPadding {
  title?: string;
  contentType: TableCellContentType.NO_PADDING;
}

interface CellWithCompact {
  title?: string;
  contentType: TableCellContentType.COMPACT;
}

interface CellWithTitleProps {
  title: string;
  contentType?: never;
}

export type ContentTypeBasedCellProps = CellWithContentTypeProps | CellWithNoPadding | CellWithCompact | CellWithTitleProps;

export type TableCellProps = TableCellBaseProps & ContentTypeBasedCellProps;
